import Button from 'components/Button';
import renderField from 'components/Field/reduxForm';
import Loading from 'components/Loading';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import { getRequiredFn, validateMinLength } from 'utils/reduxForm/validations';
import validate from './validate';

const formName = 'setCodeWord';
const required = getRequiredFn();
const minLength = validateMinLength(3, 'Контрольное слово должно быть не менее 3 символов');

class SetCodeWordForm extends React.Component {
  static propTypes = {
    innerError: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
  };

  render() {
    const { handleSubmit, innerError, loading } = this.props;
    return (
      <div>
        <form onSubmit={handleSubmit}>
          <h2>Задайте контрольное слово</h2>
          <div className="page_margin20">
            Это слово понадобится для восстановления пароля. Его можно будет изменить в Вашем
            профиле Личного кабинета.
          </div>
          <Field
            name="codeWord"
            type="password"
            component={renderField}
            label="Контрольное слово (минимум 3 символа)"
            validate={[required, minLength]}
            maxLength={100}
          />
          <Field
            name="codeWordConfirm"
            type="password"
            component={renderField}
            label="Контрольное слово еще раз"
            validate={[required, minLength]}
            maxLength={100}
          />
          {innerError ? <p className="red">{innerError}</p> : null}
          <div className="cRow cRow__tablet">
            <div className="cCol">
              <Button
                isDisabled={loading}
                buttonStyle={{ position: 'relative', minWidth: '210px' }}
                onClick={noop}
                type="submit"
                size="medium"
                color="orange"
              >
                {loading ? <Loading isLight={true} /> : 'Подтвердить'}
              </Button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: formName,
  validate,
})(SetCodeWordForm);
